import { AxnAdminConfigState } from "@idw-types/state/axn-admin-config-state";
import { AxnAdminConfigActionTypes, AxnAdminConfigActions } from "../actions/axn-admin-config-actions";

export const initialAxnAdminConfigState: AxnAdminConfigState = {
    isRefreshing: false,
    lastRefreshDate: null,
    refreshResults: null
};

export const axnAdminConfigReducer = (
    state: AxnAdminConfigState = initialAxnAdminConfigState,
    action: AxnAdminConfigActions
): AxnAdminConfigState => {
    switch(action.type) {
        case AxnAdminConfigActionTypes.SET_AXN_ADMIN_CONFIG_REFRESHING:
            return {
                ...state,
                isRefreshing: action.payload.isRefreshing
            };
        case AxnAdminConfigActionTypes.SET_AXN_ADMIN_CONFIG_REFRESH_RESULTS:
            return {
                ...state,
                isRefreshing: false,
                refreshResults: action.payload.refreshResults,
                lastRefreshDate: action.payload.lastRefreshDate,
            };
        default:
            return state;
    }
};